import { useState } from "react"
import classNames from "classnames"

/**
 * Avatar with graceful image fallback.
 *
 * Shows the LinkedIn-hosted `picture_url` from Pearch when available, and
 * falls back to the initials on:
 *   - empty / missing url
 *   - known placeholder silhouette (stripped upstream in getPictureUrl)
 *   - broken network fetch (onError)
 *
 * Two sizes — the small circle used in the list row, and the larger one
 * used in the dossier modal's header.
 */
const Avatar = ({ url, initials, size = "small", className }) => {
  const [failed, setFailed] = useState(false)
  const showImage = Boolean(url) && !failed

  return (
    <div
      className={classNames(
        "sourcing-avatar",
        `sourcing-avatar--${size}`,
        className
      )}
      aria-hidden
    >
      {showImage ? (
        <img
          src={url}
          alt=""
          loading="lazy"
          onError={() => setFailed(true)}
        />
      ) : (
        <span className="sourcing-avatar__initials">{initials || "?"}</span>
      )}
    </div>
  )
}

export default Avatar
